import axios from 'axios';

export default {
    methods: {
        async panelDecodifica(codigo, ok, err) {
            try {
                let r = await axios.post('panel/decodifica', {codigo: codigo});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async panelCaracteristica(d, ok, err) {
            try {
                let r = await axios.post('panel/caracteristica', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/panel.js